import { useSyncExternalStore } from "react";

// Whether the landing page's quick tour (pages/StudentTour.js) is open. While it is, the chat
// opens as a plain window: no "Welcome back" window and no jump back into an unfinished test,
// which would load the test from the server and cover the tour. Once the tour closes, the chat
// (if it's still open) does its usual check.

let open = false;
const listeners = new Set();

export const setQuickTourOpen = (value) => {
  if (open === value) return;
  open = value;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useQuickTourOpen = () => useSyncExternalStore(subscribe, () => open);
